import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { BooleanField, DatagridConfigurable, FunctionField, List, ReferenceField, ReferenceManyField, TextField, TextInput, } from "react-admin";
import { ListActions } from "../../components/ListActions";
import { ChipList } from "../../components/ChipList";
import { Typography } from "@mui/material";
import { generateRowClickHandler } from "../../services/RowClickService";
import { useTenantStore } from "../../providers/TenantContextProvider";
import { electionSearchQuery, electionSearchText } from "../../services/ElectionSearch";
import { translateFromPresentation } from "@sequentech/ui-core";
import { useTranslation } from "react-i18next";
var OMIT_FIELDS = ["id", "is_consolidated_ballot_encoding", "spoil_ballot_option"];
var Filters = [
    _jsx(TextInput, { label: "Name", source: "_or", parse: electionSearchQuery, format: electionSearchText }, 0),
    _jsx(TextInput, { label: "Description", source: "description" }, 1),
    _jsx(TextInput, { label: "ID", source: "id" }, 2),
    _jsx(TextInput, { label: "Election Event ID", source: "election_event_id" }, 3),
];
/** The record's name in the interface language, from its presentation. */
var PresentationName = function () {
    var i18n = useTranslation().i18n;
    return (_jsx(FunctionField, { render: function (record) {
            return translateFromPresentation(record, "name", i18n.language, {
                defaultLanguageCode: "en",
            });
        } }));
};
export var ListElection = function (_a) {
    var aside = _a.aside;
    var tenantId = useTenantStore()[0];
    var _b = React.useState(false), openDrawer = _b[0], setOpenDrawer = _b[1];
    var rowClickHandler = generateRowClickHandler(["election_event_id"]);
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h5", children: "Elections" }), _jsx(List, { actions: _jsx(ListActions, { open: openDrawer, setOpen: setOpenDrawer, withFilter: true }), filter: { tenant_id: tenantId || undefined }, aside: aside, filters: Filters, children: _jsxs(DatagridConfigurable, { rowClick: rowClickHandler, omit: OMIT_FIELDS, children: [_jsx(TextField, { source: "id" }), _jsx(PresentationName, { label: "Name" }), _jsx(TextField, { source: "description" }), _jsx(BooleanField, { source: "is_consolidated_ballot_encoding" }), _jsx(BooleanField, { source: "spoil_ballot_option" }), _jsx(ReferenceManyField, { label: "Contests", reference: "sequent_backend_contest", target: "election_id", children: _jsx(ChipList, { source: "sequent_backend_contest", filterFields: ["election_event_id", "election_id"] }) }), _jsx(ReferenceField, { source: "election_event_id", reference: "sequent_backend_election_event", children: _jsx(PresentationName, {}) })] }) })] }));
};
